import { ReactNode } from 'react';

import { Typography, Stack, tokens } from '@cast/design-system';

type Props = {
  title: string;
  children: ReactNode;
};

export const FeatureComparisonCard = ({ title, children }: Props) => {
  return (
    <Stack
      flex={1}
      minWidth={0}
      gap="16px"
      px="12px"
      py="8px"
      sx={{
        border: '1px solid',
        borderColor: tokens.theme.border.structural.neutral,
        borderRadius: '4px',
      }}
    >
      <Typography variant="h6" color={tokens.theme.fg.structural.primary}>
        {title}
      </Typography>
      {children}
    </Stack>
  );
};
